import Joi from 'joi';
import categoryCollectionCarouselSlideSchema from '@utils/validate/blocksSchemes/categoryCollectionCarouselSlideSchema';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
const categoryCollectionCarouselSchema = Joi.object({
  type: Joi.string().valid('categoryCollectionCarousel').required(),
  code: Joi.string().allow('', null).required(),
  staticDescription: Joi.boolean().required(),
  title: Joi.string().allow('', null).required(),
  titleColor: Joi.string().allow('', null).required(),
  description: Joi.string().allow('', null).required(),
  descriptionColor: Joi.string().allow('', null).required(),
  slides: Joi.array().items(categoryCollectionCarouselSlideSchema),
  ...blockAppearanceSchema
}).unknown(true);
export default categoryCollectionCarouselSchema;